import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { TableViewTypes } from './actionTypes';
import {
  getTableViewListSuccess,
  getTableViewListFail,
  createTableViewSuccess,
  createTableViewFail,
  updateTableViewSuccess,
  updateTableViewFail,
  deleteTableViewSuccess,
  deleteTableViewFail,
} from './actions';

import {
  getTableViewOptions,
  createTableView,
  updateTableView,
  deleteTableView,
} from '../../helpers/tableViews_helper';

function* getTableViewOptionsSaga(payload: any) {
  try {
    const response: Promise<any> = yield call(getTableViewOptions, payload);
    yield put(getTableViewListSuccess(response));
  } catch (error) {
    yield put(getTableViewListFail(error));
  }
}

function* createTableViewSaga(payload: any) {
  try {
    const response: Promise<any> = yield call(createTableView, payload);
    if (response !== null || response !== undefined) {
      yield put(createTableViewSuccess(response));
      getTableViewOptionsSaga(payload);
    }
  } catch (error) {
    yield put(createTableViewFail(error));
  }
}

function* updateTableViewSaga(payload: any) {
  try {
    const response: Promise<any> = yield call(updateTableView, payload);
    if (response !== null || response !== undefined) {
      yield put(updateTableViewSuccess(response));
      getTableViewOptionsSaga(payload);
    }
  } catch (error) {
    yield put(updateTableViewFail(error));
  }
}

function* deleteTableViewSaga(payload: any) {
  try {
    const response: Promise<any> = yield call(deleteTableView, payload);
    yield put(deleteTableViewSuccess(response));
    getTableViewOptionsSaga(payload);
  } catch (error) {
    yield put(deleteTableViewFail(error));
  }
}

function* tableViewsSaga() {
  yield takeEvery(TableViewTypes.GET_TABLE_VIEWLIST, getTableViewOptionsSaga);
  yield takeEvery(TableViewTypes.CREATE_TABLE_VIEW, createTableViewSaga);
  yield takeEvery(TableViewTypes.UPDATE_TABLE_VIEW, updateTableViewSaga);
  yield takeLatest(TableViewTypes.DELETE_TABLE_VIEW, deleteTableViewSaga);
}

export default tableViewsSaga;
